import { RedactFullString } from '@faceup/ui'
import type { ReactNode } from 'react'
import { useRedaction } from './RedactionProvider'
import type { RedactTextType } from './redactionConstants'
import { getTextByTextType } from './redactText'

type AttachmentRedactProps = {
  children: ReactNode
  type: RedactTextType
  text: string
}

export const AttachmentRedact = (props: AttachmentRedactProps) => {
  const { children, type, text: originalText } = props
  const { isRedactionActive, texts, redactText } = useRedaction()

  if (isRedactionActive) {
    const redactedText = getTextByTextType(texts, type)
    const text = redactedText ?? originalText

    return (
      <RedactFullString
        onClick={() => {
          redactText(
            type,
            {
              start: 0,
              end: text.length,
              variant:
                redactedText === undefined || redactedText === originalText
                  ? 'redacted'
                  : 'notRedacted',
            },
            originalText
          )
        }}
        text={text}
      />
    )
  }

  return <>{children}</>
}
